// Shared client-side validation for Civic Lens auth forms (sign-in, sign-up, etc.)

// Returns the first { type: 'required', message } for an empty field, or null if all are filled.
export const validateRequired = (fields) => {
  for (const { value, message } of fields) {
    const isEmpty = typeof value === 'string' ? !value.trim() : !value
    if (isEmpty) {
      return { type: 'required', message }
    }
  }
  return null
}

// Basic email-format check for client-side feedback before submitting. Mirrors
// the loose "something@something.tld" shape; the server remains the source of truth.
export const isValidEmailFormat = (email) => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((email || '').trim())
}
